export default {
  addAccount: '添加帳號',
  name: '姓名',
  namePlaceholder: '請輸入姓名',
  email: '郵箱',
  emailPlaceholder: '請輸入郵箱',
  search: '搜索',
  phone: '手機號',
  phonePlaceholder: '請輸入手機號',
  role: '角色',
  rolePlaceholder: '請選擇角色',
  status: '狀態',
  createTime: '創建時間',
  actions: '操作',
  edit: '編輯',
  disable: '禁用',
  enable: '啟用',
  delete: '刪除',
  active: '進行中',
  disabled: '已禁用',
  operation: '運營',
  addAccountTitle: '添加帳號',
  editAccountTitle: '編輯帳號',
  loginEmail: '請輸入登錄郵箱',
  selectCountry: '請選擇國家/地區',
  password: '密碼',
  passwordPlaceholder: '請輸入密碼',
  selectRole: '請選擇角色',
  cancel: '取消',
  confirm: '確定',
  resetPassword: '重置密碼',
  newPassword: '新密碼',
  newPasswordPlaceholder: '請輸入新密碼',
  yes: '是',
  no: '否',
  confirmDelete: '確定刪除該帳號嗎？',
};
